import { z } from "zod";

export const modalPreMediaRequestDetailsFormSchema = z.object({
  comment: z.string().min(2),
});

export type ModalPreMediaRequestDetailsFormSchema = z.infer<
  typeof modalPreMediaRequestDetailsFormSchema
>;
